<app-header></app-header>

<app-search-filters (searchOption)="searchMidwife($event)" (clear)="clearFilter()"></app-search-filters>

<app-profile-list></app-profile-list>

<app-footer></app-footer>
